import { Link } from 'react-router-dom';
import { featuredComics } from '@/mocks/comics';

export default function FeaturedGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 whitespace-nowrap">
              热门<span className="text-primary-500">作品</span>
            </h2>
            <p className="text-sm text-foreground-500 mt-2">大家都在看的精彩韩漫</p>
          </div>
          <Link
            to="/category"
            className="px-4 py-2 rounded-full bg-secondary-500 text-background-50 text-xs font-medium hover:bg-secondary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部
          </Link>
        </div>

        <div className="flex gap-5 overflow-x-auto pb-4 scrollbar-hide -mx-4 px-4 md:px-0">
          {featuredComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="flex-shrink-0 w-[180px] md:w-[220px] group cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-lg mb-3">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  title={`${comic.title} - 韩漫漫画网`}
                  className="w-full aspect-[5/7] object-cover object-top group-hover:scale-105 transition-transform duration-400"
                  loading="lazy"
                />
                <div className="absolute top-2 right-2 px-2 py-0.5 rounded-full bg-primary-500/90 text-background-50 text-xs font-bold whitespace-nowrap">
                  {comic.rating}
                </div>
                {comic.status === '已完结' && (
                  <div className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-secondary-500/90 text-background-50 text-xs font-medium whitespace-nowrap">
                    已完结
                  </div>
                )}
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1 whitespace-nowrap">
                {comic.title}
              </h3>
              <div className="flex items-center justify-between mt-1">
                <span className="text-xs text-foreground-500 whitespace-nowrap">{comic.category}</span>
                <span className="text-xs font-bold text-primary-500 whitespace-nowrap">{comic.views}</span>
              </div>
              <p className="text-xs text-foreground-400 mt-1 line-clamp-1">{comic.description}</p>
            </Link>
          ))}
          <div className="flex-shrink-0 w-[60px] md:w-[80px] flex items-center justify-center">
            <Link
              to="/category"
              className="w-10 h-10 rounded-full bg-background-200 flex items-center justify-center text-foreground-400 hover:text-primary-500 hover:bg-background-300 transition-colors duration-200 cursor-pointer"
            >
              <i className="ri-arrow-right-line text-lg"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}